import { createSelector } from 'reselect';
import { isEquivalentTestStationArrays } from './util';

/** ************************************
 * HELPERS - SLICES
 */

const selectSliceCisView = (state = {}) => {
	const { cisview } = state;
	return cisview || state;
}

const selectSliceTestStations = (state = {}) => {
	const slice = selectSliceCisView(state);
	const { testStations } = slice;
	return testStations || slice;
}

const selectSliceReadings = (state = {}) => {
	const slice = selectSliceCisView(state);
	const { readings } = slice;
	return readings || slice;
}


/** ************************************
 * SELECTORS
 */

export const selectSelectedTestStations = (state = {}) => { 
	const slice = selectSliceTestStations(state);
	const { selected } = slice;
	return selected;
}

export const selectCachedDefaultTestStations = (state = {}) => { 
	const slice = selectSliceTestStations(state);
	const { cachedDefaultTestStations } = slice;
	return cachedDefaultTestStations;
}

export const selectCachedServerTestStations = (state = {}) => { 
	const slice = selectSliceTestStations(state);
	const { cachedServerTestStations } = slice;
	return cachedServerTestStations;
}

export const selectConvertedReadings = (state = {}) => { 
	const slice = selectSliceReadings(state);
	const { convertedReadings } = slice;
	return convertedReadings;
}

export const selectIsLoading = (state = {}) => { 
	const slice = selectSliceTestStations(state);
	const { isLoading } = slice;
	return isLoading;
}

export const selectIsLoaded = (state = {}) => { 
	const slice = selectSliceTestStations(state);
	const { isLoaded } = slice;
	return isLoaded;
}

export const selectIsSaving = (state = {}) => { 
	const slice = selectSliceTestStations(state);
	const { isSaving } = slice;
	return isSaving;
}

export const selectErrorMessage = (state = {}) => { 
	const slice = selectSliceTestStations(state);
	const { errorMessage } = slice;
	return errorMessage;
}

export const selectHasError = (state = {}) => { 
	const errorMessage = selectErrorMessage(state);
	return !!errorMessage;
}

export const selectTimeuuid = (state = {}) => { 
	const slice = selectSliceTestStations(state);
	const { timeuuid } = slice;
	return timeuuid;
}


/** ************************************
 * COMPUTED SELECTORS
 */

export const selectHasChanges = createSelector(
	selectSelectedTestStations,
	selectCachedServerTestStations,
	selectCachedDefaultTestStations,
	(clientTestStations, serverTestStations, defaultTestStations) => {
		const isServerTestStations = isEquivalentTestStationArrays(clientTestStations, serverTestStations);
		const isDefaultTestStations = isEquivalentTestStationArrays(clientTestStations, defaultTestStations);
		const isServerTestStationsEmpty = (serverTestStations || [])?.length === 0;

		if (isServerTestStationsEmpty && isDefaultTestStations) {
			return false;
		}

		if (!isServerTestStationsEmpty && isServerTestStations) {
			return false;
		}

		return true;
	}
);


export const selectIsDefaultTestStations = createSelector(
	selectSelectedTestStations,
	selectCachedDefaultTestStations,
	(clientTestStations, defaultTestStations) => {
		return isEquivalentTestStationArrays(clientTestStations, defaultTestStations);
	}
);

